import { gsap, ScrollTrigger } from 'gsap/all'
import { useEffect, useRef, MutableRefObject } from 'react'
import { useIsLargeScreen } from 'src/helpers/layout'
import { createShowFromBottomAnimation } from 'src/helpers/animations'

if (typeof window !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger)
}

export const useBasicTeaserAnimations = (
  subtitleRef: MutableRefObject<HTMLDivElement>,
  largeTitleRef: MutableRefObject<HTMLDivElement>,
  contentRef: MutableRefObject<HTMLDivElement>,
  imgRef: MutableRefObject<HTMLDivElement>,
  footerButtonRef: MutableRefObject<HTMLDivElement>,
  statisticsSubtitleRef?: MutableRefObject<HTMLElement | null>
) => {
  const timeline = useRef(gsap.timeline())
  const isLarge = useIsLargeScreen()

  const animations = () => {
    createShowFromBottomAnimation(timeline.current, subtitleRef.current)
    createShowFromBottomAnimation(timeline.current, largeTitleRef.current)
    createShowFromBottomAnimation(timeline.current, contentRef.current)
    createShowFromBottomAnimation(timeline.current, imgRef.current)
    createShowFromBottomAnimation(timeline.current, footerButtonRef.current)
    if (statisticsSubtitleRef?.current) {
      createShowFromBottomAnimation(timeline.current, statisticsSubtitleRef.current)
    }
  }

  useEffect(() => {
    if (isLarge === null) {
      return
    }

    animations()
  }, [isLarge])
}

export default {}
